import Box from '@zenbusiness/zui/Box';
import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';
import { FocusGrid, ContainerGrid, PageFocusItem } from '#client/components/Grid';

import StatementContent from './components/StatementContent/StatementContent';

export default function StatementsModal({ handleClose }) {
  return (
    <FormModal handleClose={handleClose}>
      <Box
        height="100%"
        width="100%"
      >
        <ContainerGrid height="100%">
          <FocusGrid height="100%">
            <PageFocusItem height="100%">
              <StatementContent handleClose={handleClose} />
            </PageFocusItem>
          </FocusGrid>
        </ContainerGrid>
      </Box>
    </FormModal>
  );
}

StatementsModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
